import { Component, OnInit } from '@angular/core';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-bsps',
  templateUrl: './bsps.component.html',
  styleUrls: ['./bsps.component.css']
})
export class BspsComponent implements OnInit {
    public grid?: GridOptions;

    constructor(private stateService: StateService) {

    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_bsp_grid')
                .setLoadDataFunction({
                    method: 3155,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'bsps_new',
                    text: 'bsps_new',
                    tooltip: 'bsps_new',
                    translateTooltip: true,
                    func: () => this.stateService?.go('bsp', { bsp_keyno: '0' }),
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
